import { take, fork, cancel, put, call, delay, select} from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import { successCareerData, failCareerData } from "../actionCreators/career";
import {showNotification} from "../actionCreators/notification";
import { getToken, getGlobalAccount, getClubList } from '../selectors';
import config from "../../config/config";


function* getCareerData( { type, productId, dateFrom, dateTo, skinId } ) {
    try {
        console.log({ type, productId, dateFrom, dateTo, skinId });
        const { token } = yield select(getGlobalAccount);
        // const clubList = yield select(getClubList);
        // const clubToken = clubList.filter(club => club.clubId === skinId).map(club => {
        //     const token = club.adminAccount ? club.adminAccount.token : club.playerAccount.token;
        //     return token;
        // });
        // const token = clubToken[0];
        const res = yield call(callApi, `${config.API_URL}/club/accounts/period/report`, 'GET', {type, productIdList: productId, dateFrom, dateTo, skinId, token });
        console.log(res);
        yield put(successCareerData(res.data.result));
    } catch (e) {
        yield put(failCareerData(e));
    }
}

export function* watchCareerData() {
    while (true) {
        const action = yield take(actionTypes.CAREER_DATA_REQUEST);
        yield fork(getCareerData, action.value);
    }
}
